// 서비스 파일 구조

import { api } from "@/comn"; // api (백앤드 호출) 라이브러리
import { comnEnvs, comnUtils } from "@/comn/utils"; // 공통유틸, 공통변수
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks"; // 폼, 그리드 스키마 정의 타입
import { values } from "lodash";
import { DefaultValue } from "recoil";
import internal from "stream";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/usr/frgnr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/frgnr`,
    colApi: `${process.env.REACT_APP_API_COLI}/api/v1/coli/comn/comn-srvc`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0919001s: `${BASE.path}/ptli0919001s`, // Foreign Transporter List !== 외국인 운송업체 목록  ==!
    ptli0919002s: `${BASE.path}/ptli0919002s`, // Foreign Transporter Registration !== 외국인 운송업체 상세  ==!
    ptli0919003s: `${BASE.path}/ptli0919003s`, // Foreign Transporter Details !== 외국인 운송업체 상세  ==!
    ptli0919006s: `${BASE.path}/ptli0919006s`, // Foreign Transporter Edit !== 외국인 운송업체 수정  ==!
    ptli0919007s: `${BASE.path}/ptli0919007s`, // Foreign Transporter Vehicle Edit !== 외국인 운송업체 수정  ==!
    ptli0919004s: `${BASE.path}/ptli0919004s`, // Foreign Transporter Vehicle Edit !== 외국인 운송업체 수정  ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // SAVE - Foreign Transporter Registration !== 외국 운송업자 신청 저장 ==!
    saveFrgnr: (data: any) => {
        return api.post(`${BASE.api}/save`, {
            ...data,
        });
    },
    // GET - Foreign Transporter List !== 외국 운송업자 신청 목록 조회 ==!
    getFrgnrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/list?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // GET - Foreign Transporter Details !== 외국 운송업자 신청 상세 조회 ==!
    getFrgnrDtl: (data: any) => {
        return api.post(`${BASE.api}/dtl`, {
            ...data,
        });
    },
    // GET - Foreign Vehicle List !== 외국 차량 신청 목록 조회 ==!
    getFrgnrVhclList: (data: any, page: number, size: number) => {
        return api.post(`${BASE.api}/vhcl/list?page=${page}&size=${size}`, {
            ...data,
        });
    },
    getSrchFrgnrVhclList: (data: any, page: number, size: number) => {
        return api.post(`${BASE.api}/srch-vhcl/list?page=${page}&size=${size}`, {
            ...data,
        });
    },
    // GET - Foreign Vehicle Details !== 외국 차량 신청 상세 조회 ==!
    getFrgnrVhclDtl: (data: any) => {
        return api.post(`${BASE.api}/vhcl/dtl`, {
            ...data,
        });
    },
    // EDIT - Foreign Transporter Modify !== 외국 운송업자 신청 수정 ==!
    updateFrgnr: (data: any) => {
        return api.post(`${BASE.api}/update`, {
            ...data,
        });
    },
    // DELETE - Foreign Transporter Modify !== 외국 운송업자 신청 삭제 ==!
    deleteFrgnr: (data: any) => {
        return api.post(`${BASE.api}/delete`, {
            ...data,
        });
    },
    // SAVE - Foreign Transporter Vehicle Information Registration !== 외국 운송업자 차량 등록 저장 ==!
    saveFrgnrVhcl: (data: any) => {
        return api.post(`${BASE.api}/save/vhcl`, {
            ...data,
        });
    },
    // EDIT - Foreign Transporter Vehicle Information Modify !== 외국 운송업자 차량 수정 ==!
    updateFrgnrVhcl: (data: any) => {
        return api.post(`${BASE.api}/update/vhcl`, {
            ...data,
        });
    },
    // DELETE - Foreign Transporter Vehicle Information Modify !== 외국 운송업자 차량 삭제 ==!
    deleteFrgnrVhcl: (data: any) => {
        return api.post(`${BASE.api}/delete/vhcl`, {
            ...data,
        });
    },
    // SAVE - Foreign Transporter Vehicle Information Registration fee !== 외국 운송업자 차량 수수료 저장 ==!
    saveFrgnrVhclFee: (data: any) => {
        return api.post(`${BASE.api}/save/vhcl/fee`, {
            ...data,
        });
    },
    // DELETE - Foreign Transporter Vehicle Information Registration fee !== 외국 운송업자 차량 수수료 취소(논리삭제제) ==!
    cnclFrgnrVhclFee: (data: any) => {
        return api.post(`${BASE.api}/save/vhcl/fee/cncl`, {
            ...data,
        });
    },
    // EDIT - Foreign Transporter License processing status !== 외국 운송업자 면허처리상태 수정 ==!
    updateFrgnrPrcssStat: (data: any) => {
        return api.post(`${BASE.api}/update/lcne/stat`, {
            ...data,
        });
    },
    // EDIT - Foreign Transporter Vehicle License processing status !== 외국 차량 면허처리상태 수정 ==!
    updateFrgnrVhclPrcssStat: (data: any) => {
        return api.post(`${BASE.api}/update/vhcl/lcne/stat`, {
            ...data,
        });
    },
    // SAVE - Foreign Vehicle Registration fee !== 외국 차량 등록 수수료 징수 저장 호출 ==!
    // saveColRgsrSrveFee: (data: any) => {
    //     return api.post(`${BASE.colApi}/rgsrSrvcFee`, {
    //         ...data,
    //     });
    // },
    // GET - Foreign Vehicle Registration fee Details !== 외국 차량 등록 수수료 징수 상세 호출 ==!
    getColBllDtl: (data: any) => {
        return api.get(
            `${BASE.colApi}/${data.bllCstmOfceCd}-${data.bllYy}-${data.bllTpCd}-${data.bllSrno}-${data.bllDgr}/bll`,
        );
    },
    getBillPrint: (bllNo: any) => {
        const intClrUrl = process.env.REACT_APP_API_CLRI;
        http: return api.get(`${intClrUrl}/api/v1/coli/comn/comn-srvc/${bllNo}/printBll`, {
            responseType: "arraybuffer",
        });
    },
    // Check for PIN Number Duplicate !== PIN 중복 조회 ==!
    getPinDuplCheck: (data: any) => {
        return api.post(`${BASE.api}/dupl`, {
            ...data,
        });
    },

    // GET - Foreign Vehicle C29 EFT Bill Print !== 외국 차량 C29 고지서 출력 ==!
    getFrgnrVhclC29Print: (data: any) => {
        return api.get(`${BASE.api}/vhcl/c29/rprt`, {
            params: comnUtils.toGetParams(data),
            responseType: "arraybuffer",
        });
    },

    // GET - Foreign Vehicle C29 License Certificate Print (Issued status only) !== 외국 차량 C29 면허 증명서 출력 (발급 완료 상태) ==!
    getFrgnrVhclC29LcnePrint: (data: any) => {
        return api.get(`${BASE.api}/vhcl/c29/lcne`, {
            params: comnUtils.toGetParams(data),
            responseType: "arraybuffer",
        });
    },
    // GET - Foreign Transporter List !== 외국 운송업자 신청 엑셀셀 목록 조회 ==!
    getFrgnrExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),
 
   // POST with body params, matching /vhcl/list pattern
getFrgnrVhclExcelList: (data: any) => api.post(`${BASE.api}/vhcl/excel`, { ...data }),
};

export const comnFnc = {
    /**
     * License Year List Function
     * !== 면허 연도 목록 함수 ==!
     *
     * @param
     * @returns lcneYyList ( License Year List 2014 ~ current year + 1 <!== 면허 연도 목록 현재연도-4 ~ 현재연도+1 ==> )
     */
    getLcneYyList: (param?: number) => {
        const currentYear = new Date().getFullYear();

        const lcneYyList = Array.from(
            { length: currentYear + 1 - (param ? currentYear + 1 - param : currentYear - 5) },
            (_, index) => {
                const year = currentYear + 1 - index;
                return { label: year.toString(), value: year.toString() };
            },
        );

        return lcneYyList;
    },

    /**
     * License Start Days and End Days
     * !== 면허 연도 유효기간 기본 셋팅 ==!
     */
    getStartDays: () => {
        let today = new Date();

        let year = today.getFullYear(); // 년도
        let month = today.getMonth() + 1; // 월
        let date = today.getDate(); // 날짜

        const result = year + "/" + month + "/" + date;

        return result;
    },
    getEndDays: () => {
        let today = new Date();
        const year = today.getFullYear();
        const lastDate = new Date(year, 11, 31);

        const lastDateOfYear = lastDate;

        return lastDateOfYear;
    },
};

export const SF_USR_FRGNR_SRCH_FORM: TFormSchema = {
    id: "form_usrFrgnrSrch",
    schema: {
        pin: {
            label: "L_PIN",
            type: "text",
            pattern: {
                value: /^[a-zA-Z0-9]{1,12}$/,
            },
        } /* Company PIN !== 업체 PIN ==!*/,
        coTin: {
            label: "L_TIN",
            type: "text",
            mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
        } /* Company TIN !== 업체 TIN ==!*/,
        coNm: {
            label: "L_CO_NM",
            type: "text",
        } /* Company Name !== 신청서 명 ==!*/,
        lcneYy: {
            label: "L_LCNE_YY",
            type: "select",
            all: false,
            options: comnFnc.getLcneYyList(),
        } /* License Year !== 면허 년도 ==!*/,
        sbmtDt: {
            type: "daterange",
            label: "L_RGST_DT",
            // start: { name: "frstRgsrDtmStr", defaultValue: comnUtils.getDate({ m: -1 }) },
            // end: { name: "frstRgsrDtmEnd", defaultValue: comnUtils.getDate() },
            start: { name: "frstRgsrDtmStr" },
            end: { name: "frstRgsrDtmEnd" },
            rangeButton: 2,
        },
        lcneAplyPrcssStatCd: {
            label: "L_STTS",
            type: "select",
            area: "comnCd",
            comnCd: "LCM0006",
        },
        vhclRgsrNo: {
            type: "text",
            label: "L_VHCL_RGSR_NO",
            pattern: {
                value: /^[A-Z0-9]+$/,
                message: "You can't enter special characters or spaces.",
            },
        },
        srchVhclYn: {
            type: "checkbox",
            label: "L_VHCL_SRCH_YN",
            options: [{label: "", value: "Y"}],
            defaultValue: 'N'
        },
    },
};

export const SF_USR_FRGNR_FORM: TFormSchema = {
    id: "form_usrFrgnr",
    schema: {
        appNo: {
            label: "L_APP_NO",
            type: "text",
        } /* Application Number !== 신청서 번호 ==!*/,
        pin: {
            label: "L_PIN",
            type: "text",
            required: true,
            maxLength: 12,
            pattern: {
                value: /^[a-zA-Z0-9]{1,12}$/,
            },
        } /* PIN !== PIN 번호 ==!*/,
        coTin: {
            label: "L_TIN",
            type: "text",
            mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
            edit: false,
        } /* Company TIN !== 업체 TIN ==!*/,
        coNm: {
            label: "L_CO_NM",
            type: "text",
        } /* Company Name !== 신청서 명 ==!*/,
        lcneYy: {
            label: "L_LCNE_YY",
            type: "select",
            options: comnFnc.getLcneYyList(),
            required: true,
        } /* License Year !== 면허 년도 ==!*/,
        lcneVldtyDays: {
            label: "L_LCNE_VLDTY_PRID",
            type: "daterange",
            required: true,
            start: { name: "lcneVldStrtDt", required: true, defaultValue: comnFnc.getStartDays() },
            end: { name: "lcneVldEndDt", required: true, defaultValue: comnFnc.getEndDays() },
        } /* License Expiration Date !== 면허 유효기간 ==!*/,
        rgsrTrdrNm: {
            label: "L_RGSR_TRDR_NM",
            type: "text",
            required: true,
        } /* Registered Trade Name !== 등록 무역업자 ==!*/,
        bizTpCd: {
            type: "select",
            label: "L_BIZ_TP",
            area: "comnCd",
            comnCd: "LCM0003",
            required: true,
        } /* Business Type !== 사업 유형 ==!*/,
        trprOwrsTrckNo: {
            type: "text",
            label: "L_TRCK_TRLR_NO",
            edit: false,
        } /* Number of trucks / trailers !== 트럭/트레일러 대수 ==!*/,
        cstmLcneNo: {
            type: "text",
            label: "L_LCNE_NO",
            edit: false,
        } /* License No !== 운전 면허 번호 ==! */,
        lcneIssDtm: {
            type: "date",
            label: "L_LCNE_ISS_DT",
        } /* License Issue Date !== 면허 발급 날짜 ==!*/,
        bizLcneNo: {
            type: "text",
            label: "L_BIZ_LCNE_NO",
        } /* Business License No !== 사업 면허 번호 ==! */,
        bizLcneIssDtm: {
            type: "date",
            label: "L_LCNE_ISS_DT",
        } /* Date of Issue !== 사업 면허 일자 ==! */,
        moblNo: {
            type: "text",
            label: "L_MOBL_NO",
            required: true,
        } /* Mobile Number !== 핸드폰 번호 ==!*/,
        appDgr: {
            type: "number",
            label: "L_DGR",
        } /* Application Degree!== 신청서 차수 ==! */,
        preLcneNo: {
            type: "text",
            label: "L_PRE_LCNE_NO",
        } /* Number of previous license !== 이전 면허 번호 ==! */,
        preLcneIssDtm: {
            type: "date",
            label: "L_PRE_LCNE_DT",
        } /* Date of Issue !== 이전 면허 일자 ==! */,
        physAddr: {
            type: "text",
            edit: false,
        } /* Physical Address !== 물리 주소 ==!*/,
        physPlotNm: {
            type: "text",
            label: "L_PLOT",
        } /* Physical Address Plot !== 물리 주소 ==!*/,
        physBlckNm: {
            type: "text",
            label: "L_BLCK",
        } /* Physical Address Block !== 물리 블록 주소 ==!*/,
        physStretNm: {
            type: "text",
            label: "L_STRET",
        } /* Physical Address Street !== 물리 거리 주소 ==!*/,
        postAddr: {
            type: "text",
            label: "L_POST_ADDR",
            edit: false,
            required: true,
        } /* Postal Address Box !== 우편 주소 ==!*/,
        postBoxNo: {
            type: "text",
            label: "L_BOX_NO",
        } /* Postal Address Box !== 우편 함 주소 ==!*/,
        postRegnCd: {
            type: "code",
            area: "comnCd",
            comnCd: "LCM0010",
            popupSize: "md",
            viewType: "label",
            label: "L_POST_REGN_NM",
        } /* Postal Address Region Code !== 우편 지역 주소 코드 ==!*/,
        postRegnNm: {
            type: "text",
            label: "L_POST_REGN_NM",
            required: true,
            hidden: true,
        } /* Postal Address Region Name !== 우편 지역 주소 명 ==!*/,
        emlAddr: {
            type: "text",
            required: true,
            placeholder: "example@gmail.com",
            pattern: { value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i, message: "The email format is incorrect" },
        } /* Email !== 이메일 ==!*/,
        postDstrNm: {
            type: "code",
            label: "L_APLC_CNTY",
            area: "cntyCd",
            popupSize: "md",
            exact: true,
            required: true,
        } /* Country !== 신청인 국가 코드 ==!*/,
        aplcCntyNm: {
            type: "text",
            area: "cntyCd",
            label: "L_APLC_CNTY",
        } /* Country !== 신청인 국가 명 ==!*/,
        rmrk: {
            type: "text",
            hidden: true,
            label: "L_RMRK",
            defaultValue: "I",
        } /* RMRK !== 외내부 구분 컬럼 ==!*/,

        usrStatCd: { type: "select", label: "L_USR_STAT_CD", area: "comnCd", comnCd: "PTL0001", select: false },
    },
};

export const SF_USR_FRGNR_VHCL_FORM: TFormSchema = {
    id: "form_usrFrgnrVhcl",
    schema: {
        vhclRgsrNo: {
            type: "text",
            label: "L_VHCL_RGSR_NO",
            required: true,
            pattern: {
                value: /^[a-zA-Z0-9]+$/,
                message: "You can't enter special characters or spaces.",
            },
        } /* Vehicle Registration Number !== 차량 등록 번호 ==!*/,
        owrNm: {
            type: "text",
            label: "L_OWR_NM",
            required: true,
        } /* Owner Name !== 소유주 이름 ==!*/,
        issRegnNm: {
            type: "text",
            label: "L_ISS_REGN_NM",
            required: true,
        } /* Issue Region Name !== 발급 지역 명 ==!*/,
        appNo: {
            label: "L_APP_NO",
            type: "text",
            readOnly: true,
        } /* Application Number !== 신청서 번호 ==!*/,
        coTin: {
            label: "L_TIN",
            type: "text",
            mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
            edit: false,
        } /* Company TIN !== 업체 TIN ==!*/,
        lcneYy: {
            label: "L_LCNE_YY",
            type: "select",
            options: comnFnc.getLcneYyList(),
        } /* License Year !== 면허 년도 ==!*/,
        cardRgsrNo: {
            type: "text",
            label: "L_RGSR_CARD_NO",
            required: true,
        } /* Registration Card Number !== 등록 카드 번호 ==!*/,
        trptAppNo: {
            type: "text",
            label: "L_TRPT_APP_NO",
            required: true,
            readOnly: true,
        } /* Transporter Application Number !== 수송 신청 번호 ==!*/,
        trptLcneNo: {
            type: "text",
            label: "L_TRPT_LCNE_NO",
            required: true,
            readOnly: true,
        } /* Transporter License Number !== 수송 면허 번호 ==!*/,
        trptIssDtm: {
            type: "date",
            label: "L_TRPT_ISS_DT",
            required: true,
            readOnly: true,
        } /* Transporter Date of Issue !== 수송 발급 일시 ==!*/,
        insrCvrPtclCn: {
            type: "text",
            label: "L_INSR_CVR_PTCL_CN",
            required: true,
        } /* Full particulars of Insurance Cover !== 보험 커버 명세 내용 ==!*/,
        latraCrteNo: {
            type: "text",
            label: "L_LATRA_TRSF_NO",
        } /* LATRA Transfer Number !== LATRA 증서 번호 ==!*/,
        atcdFileDto: {
            type: "file",
            accept: "application/pdf",
            label: "L_VHCL_RGSR_CRD",
            required: true,
        },
        vhclMkerNm: {
            type: "text",
            label: "L_VHCL_MKER_CD",
            required: true,
        } /* Vehicle Maker !== 차량 제조사 ==!*/,
        vhclBodyTpNm: {
            type: "text",
            label: "L_BODY_TP",
            required: true,
        } /* Body Type !== 차체 유형 ==!*/,
        lcneIssDtm: {
            type: "date",
            label: "L_LCNE_ISS_DT",
            //required: true,
        } /* License Issue Date !== 면허 발급 날짜 ==!*/,
        lcneVldtyDays: {
            label: "L_LCNE_VLDTY_PRID",
            type: "daterange",
            required: true,
            start: { name: "lcneVldStrtDt", required: true, defaultValue: comnFnc.getStartDays() },
            end: { name: "lcneVldEndDt", required: true, defaultValue: comnFnc.getEndDays() },
        } /* License Expiration Date !== 면허 유효기간 ==!*/,
        moblNo: {
            type: "text",
            label: "L_MOBL_NO",
            required: true,
        } /* Mobile Number !== 핸드폰 번호 ==!*/,
        mnfcYy: {
            type: "number",
            label: "L_YY_MNFC",
            required: true,
            maxLength: "4",
            placeholder: "Year",
            pattern: { value: /^[0-9]+$/, message: "You can only enter numbers." },
            thousandSeparator: false,
        } /* Year of Manufacture !== 생산년도 ==!*/,
        vhclClrNm: {
            type: "text",
            label: "L_CLR",
            required: true,
        } /* Color !== 색상 ==!*/,
        engnNo: {
            type: "text",
            label: "L_ENGN_NO",
            required: true,
        } /* Engine No. !== 엔진 번호 ==!*/,
        vhclDpacInfoCn: {
            type: "number",
            label: "L_CC",
            required: true,
            maxLength: "5",
            thousandSeparator: false,
        } /* CC !== CC ==!*/,
        vhclAxleNo: {
            type: "number",
            label: "L_VHCL_AXLE_NO",
            required: true,
            maxLength: "2",
        } /* Number of Axle !== 축의 번호 ==!*/,
        chssNo: {
            type: "text",
            label: "L_CHSS_NO",
            required: true,
        } /* Chassis No. !== 샤시 번호 ==!*/,
        tankrYn: {
            type: "checkbox",
            label: "L_TANKR_YN",
            options: [{ label: "", value: "Y" }],
        } /* Tanker Y/N !== 탱커 여부 ==!*/,
        trnsGodsIdtnYn: {
            type: "checkbox",
            label: "L_TRANS_GODS_YN",
            required: true,
            options: [{ label: "", value: "Y" }],
        } /* TRANSIT GOODS !== 트랜짓 물품 표시 여부 ==!*/,
        carygCapc: {
            type: "text",
            label: "L_CARYG_CAPC",
        } /* Carrying Capacity !== 운반_용량 ==!*/,
        trptVhclMlg: {
            type: "number",
            label: "L_MLG_NVAL",
            maxLength: "20",
        } /* Mileage !== 연비_수치값 ==! */,
        emptWght: {
            type: "number",
            label: "L_EMPT_WGHT",
            maxLength: "18",
        } /* Weight Empty !== 빈_중량 ==! */,
        rmrk: {
            type: "text",
            hidden: true,
            label: "L_RMRK",
            defaultValue: "I",
        } /* RMRK !== 외내부 구분 컬럼 ==!*/,
    },
};

export const SF_USR_VRFN_APRV_FORM: TFormSchema = {
    id: "form_usrVrfnAprv",
    schema: {
        lcneTpCd: {
            type: "select",
            label: "L_LCNE_TP",
            area: "comnCd",
            comnCd: "LCM0001",
            viewType: "label",
            excludes: ["14"],
        },
        lcneYy: {
            type: "text",
            label: "L_LCNE_YY",
        },
        coTin: {
            type: "text",
            label: "L_TIN",
            mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
        },
        lcneAplyPrcssStatCd: {
            //License Application Processing Status !== 면허신청 처리현황 ==!
            label: "L_PRCSS_STAT",
            type: "code",
            area: "comnCd",
            comnCd: "LCM0006",
            viewType: "label",
        },
        coNm: {
            type: "text",
            label: "L_CO_NM",
        },
        aprvOfcr: {
            type: "text",
            label: "L_APRV_OFCR",
        },
        aprvDt: {
            type: "text",
            label: "L_APRV_DT",
        },
        btnTp: {
            type: "text",
            label: "Final Result",
        },
        rcveOfcr: {
            type: "radio",
            label: "Received Offier",
            options: [
                { label: "Verify Offier", value: "D" },
                { label: "Inspection Offier", value: "6" },
            ],
        },
        rmrk: {
            type: "textarea",
            label: "L_RMRK",
            rows: 7,
            controlSize: 12,
        },
        atcdFileDto: {
            type: "file",
            multiple: true,
            label: "L_File",
            controlSize: 10,
            disableName: true,
            disableDescription: true,
            disableTitle: true,
        },
    },
};

export const SF_FEE_TAB_FROM: TFormSchema = {
    id: "form_fee",
    schema: {
        impsStat: {
            label: "L_IMPS_STAT",
            type: "radio",
            options: [
                { label: "Imposed", value: "D" },
                { label: "Not Applicable", value: "6" },
            ],
        } /* Impose Status !== 부과 상태 ==!*/,
        bllSrno: {
            label: "L_BLL_NO",
            type: "text",
        } /* Bill No. !== 고지서 번호 ==!*/,
        payTpCd: {
            label: "L_PAY_TP",
            type: "radio",
            options: [
                { label: "Cash", value: "C" },
                { label: "Bank", value: "R" },
            ],
            required: true,
            defaultValue: "R",
        } /* Payment Type !== 납부유형 ==!*/,
        frgnVhclRgsrBllIssYn: {
            label: "L_BLL_ISS_YN",
            type: "radio",
            options: [
                { label: "Imposed", value: "Y" },
                { label: "Not Applicable", value: "N" },
            ],
            required: true,
        } /* Payment Bill Issue Y/N !== 고지서 발급 여부 ==!*/,
        frgnVhclRgsrBllNo: {
            label: "L_RGSR_BLL_NO",
            type: "text",
        } /* Payment Bill Registration Number !== 등록 고지서 번호 ==!*/,
        frgnVhclRgsrBllIssDtm: {
            label: "L_BLL_ISS_DT",
            type: "text",
        } /* Payment Bill Issue Date And Time !== 고지서 발급 일시 ==!*/,
        roadFeeTzs: {
            label: "L_ROAD_FEE_TZS",
            type: "text",
            required: true,
        } /* Payment type !== 납부 유형 ==!*/,
        frgnVhclRgsrPayDtm: {
            label: "L_PAY_DT",
            type: "text",
        } /* Payment Date !== 납부 일자 ==!*/,
        frgnVhclRgsrRcptNo: {
            label: "L_RCPT_NO",
            type: "text",
        } /* Receipt No. !== 영수증 번호 ==!*/,
        frgnVhclRgsrRcptDtm: {
            label: "L_RCPT_DT",
            type: "text",
        } /* Receipt Date !== 영수증 날짜 ==!*/,
        frgnVhclRgsrFeeVal: {
            label: "L_RGSR_FEE_PRC",
            type: "number",
            required: true,
            maxLength: "18",
            defaultValue: 300,
        } /* Registration fee price !== 등록 수수료 가격 ==!*/,
        frgnVhclRgsrFeeTzsVal: {
            label: "L_RGSR_FEE_TZS_PRC",
            type: "number",
            maxLength: "18",
        } /* Registration fee price !== 등록 수수료 가격 ==!*/,
        frgnVhclRgsrFeeCurrCd: {
            label: "L_CURR_CD",
            type: "text",
        } /* Registration fee price !== 등록 수수료 가격 ==!*/,
    },
};

export const SG_SEARCH_FRGNR_LIST: TGridSchema = {
    id: "grid_frgnrList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_PIN", binding: "pin", width: "8%" }], id: "pin" },
        { cells: [{ header: "L_TIN", binding: "coTin", width: "8%" }], id: "coTin", show: false },
        { cells: [{ header: "L_LCNE_YY", binding: "lcneYy", width: "5%" }], id: "lcneYy" },
        { cells: [{ header: "L_APP_NO", binding: "appNo", width: "8%" }], id: "appNo" },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }], id: "coNm" },
        { cells: [{ header: "L_CSTM_LCNE_NO", binding: "cstmLcneNo", width: "7%" }], id: "cstmLcneNo" },
        { cells: [{ header: "L_SBMT_DTM", binding: "sbmtDtm", width: "12%" }], id: "sbmtDtm" },
        { cells: [{ header: "L_LCNE_ISS_DT", binding: "lcneIssDtm", width: "12%" }], id: "lcneIssDtm" },
        { cells: [{ header: "L_LCNE_XPIR_DT", binding: "lcneVldEndDt", width: "7%" }], id: "lcneVldEndDt" },
        { cells: [{ header: "L_VHCL_CNT", binding: "trprOwrsTrckNo", width: "5%" }], id: "trprOwrsTrckNo" },
        { cells: [{ header: "L_STTS", binding: "lcneAplyPrcssStatCd", width: "7%" }], id: "lcneAplyPrcssStatCd" },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCd", width: "5%" }], id: "usrStatCd" },
    ],
    body: [
        { cells: [{ binding: "pin" }] } /* Company PIN !== 업체 PIN ==!*/,
        {
            cells: [
                {
                    binding: "coTin",
                    type: "text",
                    mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
                },
            ],
        } /* Company TIN !== 업체 TIN ==!*/,
        { cells: [{ binding: "lcneYy" }] } /* License Year !== 면허 년도 ==! */,
        { cells: [{ binding: "appNo" }] } /* Application Number !== 신청서 번호 ==!*/,
        { cells: [{ binding: "coNm", align: "left" }] } /* Company Name !== 신청서 명 ==!*/,
        { cells: [{ binding: "cstmLcneNo" }] } /* License Number !== 면허 번호 ==!*/,
        { cells: [{ binding: "sbmtDtm", type: "datetime" }] } /* License Sumit Date !== 면허 제출 날짜 ==!*/,
        { cells: [{ binding: "lcneIssDtm", type: "datetime" }] } /* License Issue Date !== 면허 발급 날짜 ==!*/,
        { cells: [{ binding: "lcneVldEndDt", type: "date" }] } /* License Expiration Date !== 면허 유효기간 ==!*/,
        { cells: [{ binding: "trprOwrsTrckNo", align: "right" }] } /* Count of Vehicle !== 차량 수 ==!*/,
        {
            cells: [
                { binding: "lcneAplyPrcssStatCd", type: "code", area: "comnCd", comnCd: "LCM0006", viewType: "label" },
            ],
        } /* Status !== 상태 ==!*/,

        { cells: [{ binding: "usrStatCd", type: "code", area: "comnCd", comnCd: "PTL0001", viewType: "label" }] },
    ],
};

export const SG_VHCL_INFO_LIST: TGridSchema = {
    id: "grid_vhclInfoList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: 200 },
    head: [
        { cells: [{ header: "L_VHCL_RGSR_NO", binding: "vhclRgsrNo", width: "*" }], id: "vhclRgsrNo" },
        { cells: [{ header: "L_RGSR_CARD_NO", binding: "cardRgsrNo", width: "*" }], id: "cardRgsrNo" },
        { cells: [{ header: "L_CHSS_NO", binding: "chssNo", width: "*" }], id: "chssNo" },
        { cells: [{ header: "L_ENGN_NO", binding: "engnNo", width: "*" }], id: "engnNo" },
        { cells: [{ header: "L_STTS", binding: "lcneAplyPrcssStatCd", width: "*" }], id: "lcneAplyPrcssStatCd" },
    ],
    body: [
        { cells: [{ binding: "vhclRgsrNo" }] } /* Vehicle Reg No. !== 차량 등록 번호 ==!*/,
        { cells: [{ binding: "cardRgsrNo" }] } /* Registration Card Number !== 등록 카드 번호 ==!*/,
        { cells: [{ binding: "chssNo" }] } /* Chassis No. !== 샤시 번호 ==!*/,
        { cells: [{ binding: "engnNo" }] } /* Engine No. !== 엔진 번호 ==!*/,
        {
            cells: [
                { binding: "lcneAplyPrcssStatCd", type: "code", area: "comnCd", comnCd: "LCM0006", viewType: "label" },
            ],
        } /* Status !== 상태 ==!*/,
    ],
};

export const AddStr = (arr: Array<any>) => {
    let result = "";
    if (!comnUtils.isUndefined(arr)) {
        arr.forEach((item) => {
            if (!comnUtils.isEmpty(item)) {
                result += (result === "" ? "" : ", ") + item;
            }
        });
    }
    return result;
};

export const SG_SEARCH_FRGNR_EXCEL_LIST: TGridSchema = {
    id: "grid_frgnrList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_PIN", binding: "pin", width: "8%" }], id: "pin" },
        { cells: [{ header: "L_TIN", binding: "coTin", width: "8%" }], id: "coTin", show: false },
        { cells: [{ header: "L_LCNE_YY", binding: "lcneYy", width: "5%" }], id: "lcneYy" },
        { cells: [{ header: "L_APP_NO", binding: "appNo", width: "8%" }], id: "appNo" },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }], id: "coNm" },
        { cells: [{ header: "L_CSTM_LCNE_NO", binding: "cstmLcneNo", width: "7%" }], id: "cstmLcneNo" },
        { cells: [{ header: "L_SBMT_DTM", binding: "sbmtDtm", width: "12%" }], id: "sbmtDtm" },
        { cells: [{ header: "L_LCNE_ISS_DT", binding: "lcneIssDtm", width: "12%" }], id: "lcneIssDtm" },
        { cells: [{ header: "L_LCNE_XPIR_DT", binding: "lcneVldEndDt", width: "7%" }], id: "lcneVldEndDt" },
        { cells: [{ header: "L_VHCL_CNT", binding: "trprOwrsTrckNo", width: "5%" }], id: "trprOwrsTrckNo" },
        { cells: [{ header: "L_STTS", binding: "lcneAplyPrcssStatCd", width: "7%" }], id: "lcneAplyPrcssStatCd" },
    ],
    body: [
        { cells: [{ binding: "pin" }] } /* Company PIN !== 업체 PIN ==!*/,
        {
            cells: [
                {
                    binding: "coTin",
                    type: "text",
                    mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
                },
            ],
        } /* Company TIN !== 업체 TIN ==!*/,
        { cells: [{ binding: "lcneYy" }] } /* License Year !== 면허 년도 ==! */,
        { cells: [{ binding: "appNo" }] } /* Application Number !== 신청서 번호 ==!*/,
        { cells: [{ binding: "coNm", align: "left" }] } /* Company Name !== 신청서 명 ==!*/,
        { cells: [{ binding: "cstmLcneNo" }] } /* License Number !== 면허 번호 ==!*/,
        { cells: [{ binding: "sbmtDtm", type: "datetime" }] } /* License Sumit Date !== 면허 제출 날짜 ==!*/,
        { cells: [{ binding: "lcneIssDtm", type: "datetime" }] } /* License Issue Date !== 면허 발급 날짜 ==!*/,
        { cells: [{ binding: "lcneVldEndDt", type: "date" }] } /* License Expiration Date !== 면허 유효기간 ==!*/,
        { cells: [{ binding: "trprOwrsTrckNo", align: "right" }] } /* Count of Vehicle !== 차량 수 ==!*/,
        {
            cells: [
                { binding: "lcneAplyPrcssStatCd", type: "code", area: "comnCd", comnCd: "LCM0006", viewType: "label" },
            ],
        } /* Status !== 상태 ==!*/,
    ],
};

export const SG_VHCL_INFO_EXCEL_LIST: TGridSchema = {
    id: "grid_vhclInfoList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_RGSR_NO", binding: "vhclRgsrNo", width: "*" }], id: "vhclRgsrNo" },
        { cells: [{ header: "L_RGSR_CARD_NO", binding: "cardRgsrNo", width: "*" }], id: "cardRgsrNo" },
        { cells: [{ header: "L_CHSS_NO", binding: "chssNo", width: "*" }], id: "chssNo" },
        { cells: [{ header: "L_ENGN_NO", binding: "engnNo", width: "*" }], id: "engnNo" },
        { cells: [{ header: "L_STTS", binding: "lcneAplyPrcssStatCd", width: "*" }], id: "lcneAplyPrcssStatCd" },
    ],
    body: [
        { cells: [{ binding: "vhclRgsrNo" }] } /* Vehicle Reg No. !== 차량 등록 번호 ==!*/,
        { cells: [{ binding: "cardRgsrNo" }] } /* Registration Card Number !== 등록 카드 번호 ==!*/,
        { cells: [{ binding: "chssNo" }] } /* Chassis No. !== 샤시 번호 ==!*/,
        { cells: [{ binding: "engnNo" }] } /* Engine No. !== 엔진 번호 ==!*/,
        {
            cells: [
                { binding: "lcneAplyPrcssStatCd", type: "code", area: "comnCd", comnCd: "LCM0006", viewType: "label" },
            ],
        } /* Status !== 상태 ==!*/,
    ],
};


// search foreign vehicles 
export const SG_VHCL_SEARCH_FRGNR_LIST: TGridSchema = {
    id: "grid_frgnrVhclList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_RGSR_NO", binding: "vhclRgsrNo", width: "16%" }], id: "vhclRgsrNo" },
        { cells: [{ header: "L_CSTM_LCNE_NO", binding: "cstmLcneNo", width: "10%" }], id: "cstmLcneNo" },
        { cells: [{ header: "L_CO_NM", binding: "owrNm", width: "*" }], id: "owrNm" },
        { cells: [{ header: "L_RGSR_CRD_NO", binding: "cardRgsrNo", width: "14%" }], id: "cardRgsrNo" },
        { cells: [{ header: "L_ENGN_NO", binding: "engnNo", width: "10%" }], id: "engnNo" },
        { cells: [{ header: "L_VHCL_CHSS_NO", binding: "chssNo", width: "10%" }], id: "chssNo" },
        { cells: [{ header: "L_STTS", binding: "lcneAplyPrcssStatCd", width: "10%" }], id: "lcneAplyPrcssStatCd" },
    ],
    body: [
        { cells: [{ binding: "vhclRgsrNo" }] } /* Vehicle Registration Number ==!*/,
        { cells: [{ binding: "cstmLcneNo" }] } /* License Number !== 면허 번호 ==!*/,
        { cells: [{ binding: "owrNm", align: "left" }] } /* Company/Owner Name !== 신청서 명 ==!*/,
        { cells: [{ binding: "cardRgsrNo", align: "left" }] } /* Card Registration Number ==!*/,
        { cells: [{ binding: "engnNo" }] } /* Engine Number ==!*/,
        { cells: [{ binding: "chssNo", align: "right" }] } /* Count of Vehicle !== 차량 수 ==!*/,
        {
            cells: [
                { binding: "lcneAplyPrcssStatCd", type: "code", area: "comnCd", comnCd: "LCM0006", viewType: "label" },
            ],
        } /* Status ==!*/,
    ],
};